module.exports = __webpack_public_path__ + "assets/img/discernment_cid_scene1.e23ec0b9.png";